import React from 'react';
import DefaultLayout from '../../../layouts/default';
import ChecklistSummary from './components/ChecklistSummary';
import CheckView from './components/CheckView';
import { ChecksProvider } from './context/ChecksContext';

function ChecksComplianceCenterPage() {
  return (
    <DefaultLayout>
      <ChecksProvider>
        <CheckView />
        <ChecklistSummary />
      </ChecksProvider>
    </DefaultLayout>
  );
}

export default ChecksComplianceCenterPage;